import { render, staticRenderFns } from "./AdminRolesView.vue?vue&type=template&id=e709b398&scoped=true"
import script from "./AdminRolesView.vue?vue&type=script&lang=js"
export * from "./AdminRolesView.vue?vue&type=script&lang=js"
import style0 from "./AdminRolesView.vue?vue&type=style&index=0&id=e709b398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e709b398",
  null
  
)

export default component.exports